/**
 * Top-level Contribution / Expenditure / Transfer / Dismiss switch at
 * the head of the classification side panel body. Generic over the
 * caller's value enum.
 */
import { cn } from '@/lib/utils';

export interface TypeToggleOption<T extends string> {
  value: T;
  label: string;
}

interface TypeToggleProps<T extends string> {
  options: ReadonlyArray<TypeToggleOption<T>>;
  selectedType: T | null;
  onSelect: (type: T) => void;
}

export function TypeToggle<T extends string>({
  options,
  selectedType,
  onSelect,
}: TypeToggleProps<T>) {
  return (
    <div className="mb-4 flex gap-2">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onSelect(opt.value)}
          className={cn(
            'flex-1 rounded-md border px-3 py-2 text-sm font-medium transition-colors',
            selectedType === opt.value
              ? 'bg-primary text-primary-foreground'
              : 'hover:bg-accent',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
